import { render, staticRenderFns } from "./request_contact.html?vue&type=template&id=54185fb3&scoped=true&"
import script from "./request_contact.js?vue&type=script&lang=js&"
export * from "./request_contact.js?vue&type=script&lang=js&"
import style0 from "./request_contact.scss?vue&type=style&index=0&id=54185fb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54185fb3",
  null
  
)

export default component.exports